import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { isUserLoggedIn } from '../../screens/auth/selectors';
import './styles.scss';

export function Footer({ isUserLoggedIn, location }) {
    const { pathname = '' } = location;
    const className = pathname.replace('/', '');
    const newDate = new Date();
    return (
        isUserLoggedIn && (
            <footer
                id="footer"
                className={`text-right ${className}`}
                style={{ paddingBottom: '0px' }}
            >
                <div className="row">
                    <div className="col-md-4 ml-auto">
                        <p className="copyRight">
                            &copy; Copyright {newDate.getFullYear()} Litterati
                        </p>
                    </div>
                </div>
            </footer>
        )
    );
}

Footer.propTypes = {
    isUserLoggedIn: PropTypes.bool,
    location: PropTypes.object,
};

const mapStateToProps = (state) => {
    return {
        isUserLoggedIn: isUserLoggedIn(state),
    };
};

const ConnectedFooter = connect(mapStateToProps)(Footer);

export default withRouter(ConnectedFooter);
